import { Directive, Input, TemplateRef, inject, input } from '@angular/core';
import { LiberroDisclaimerComponent } from '../liberro-disclaimer/liberro-disclaimer.component';

@Directive({
  selector: 'ng-template[liberroTab]',
  standalone: false,
})
export class LiberroTabDirective {
  public template = inject<TemplateRef<LiberroDisclaimerComponent>>(TemplateRef);

  @Input('liberroTab') public label = '';
  @Input() public dataCy = '';
  public liberroIconSrc = input<string>();
}

